export const CacheKeys = {
  OrderBlotterColumns: "trader2b-order-blotter-columns",
  PositionBlotterColumns: "trader2b-position-blotter-columns",
  TimeAndSalesColumns: "trader2b-time-and-sales-columns",
  WatchListColumns: "trader2b-watch-list-columns",
  AGGridColumns: "trader2b-ag-grid-columns"
};
